
import { Injectable } from '@angular/core';
import { MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';
import { ContactFormModalComponent } from '../../shared/Components/contact-form-modal/contact-form-modal.component';
import { CalculatorCaseSelectModalComponent } from '../Components/calculator-case-select-modal/calculator-case-select-modal.component';
import { CaseDto } from '../Models/CaseDto';

@Injectable({
  providedIn: 'root',
})
export class ModalService {

  public contactFormDialogRef!: MatDialogRef<ContactFormModalComponent>;

  constructor(private dialog: MatDialog) {}

  public openContactModal(): void {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.hasBackdrop = true;
    dialogConfig.autoFocus = false;
    const dialogRef = this.dialog.open(ContactFormModalComponent, dialogConfig);
    this.contactFormDialogRef = dialogRef;
  }

  public openCaseSelectForCalculatorModal(casesToShow: CaseDto[]): MatDialogRef<CalculatorCaseSelectModalComponent> {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.hasBackdrop = true;
    dialogConfig.autoFocus = false;
    dialogConfig.data = {
      myObjectHolder: casesToShow,
    };
    const dialogRef = this.dialog.open(CalculatorCaseSelectModalComponent, dialogConfig);
    return dialogRef;
  }

}
